import type { Staff } from "@/lib/authv2/store";
import { canReadPayroll } from "@/features/payroll/permissions";
import { ACTION } from "@/lib/auth/actions";
import { hasPermission } from "@/lib/authv2/permissions";

/** Same read gate as payroll history.
 *
 * NOTE: Delegates to canReadPayroll (ACTION-mode via PayrollRead).
 * No separate salary.analytics.read action during Model A. */
export function canReadSalaryAnalytics(staff: Staff | null): boolean {
  return canReadPayroll(staff);
}

/** Khối cảnh báo lương + cột cảnh báo: CHỈ admin + director (fraud.read, CEO 6a).
 * Máy chủ cũng không gửi khối này cho người khác — đây chỉ để màn khỏi vẽ khung rỗng. */
export function canSeeSalaryAlerts(): boolean {
  return hasPermission(ACTION.FraudRead);
}

/** Sửa ngưỡng cảnh báo lương trong Cài đặt (admin + director). */
export function canWriteSalaryThresholds(): boolean {
  return hasPermission(ACTION.SalaryAlertThresholdWrite);
}
